export var DEFAULT_HEADER_COLOR = 'rgb(51, 204, 238)';
export var DEFAULT_HEADER_TEXT_COLOR = '#ffffff';
//# sourceMappingURL=default-widget-colors.js.map